import React, { useEffect, useState } from "react";
import { MainBg } from "../../layouts/MainBg";
import { Link, useParams } from "react-router-dom";
import dottedbg from "../../assets/home/dotted-bg.png";

import axios from "axios";
import { PolicyPagesData } from "../../datafactory/PolicyPagesData";
import { GET_GENERAL_PAGES } from "../../config/ApiCollection";

const MainPolicyPages = () => {
  const { pagename } = useParams();
  const [policyData, setPolicyData] = useState();
  const [loading, setLoading] = useState(true);
  const expected_page_name = [
    { pagename: "terms_of_services", pageurl: "terms" },
    { pagename: "privacy_policy", pageurl: "privacy-policy" },
    {
      pagename: "trusted_sources",
      pageurl: "trusted-sources",
    },
    { pagename: "contacts", pageurl: "contact" },
  ];

  const GetPolicyPage = async () => {
    setLoading(true);
    const get_header = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      await axios
        .post(GET_GENERAL_PAGES, { country: "us" }, get_header)
        .then((response) => {
          PolicyFind(response.data);
        });
    } catch (error) {
      setLoading("error");
    }
  };

  const PolicyFind = (PolicyAllData) => {
    const page = expected_page_name?.find((item) => item.pageurl === pagename);

    if (page) {
      // If a matching pageurl is found, filter the data by pagename
      const filteredData = PolicyAllData?.filter(
        (item) => item.name === page.pagename
      );
      setPolicyData(
        filteredData && filteredData[0] && filteredData[0]?.description
      );
      setLoading(false);
    } else {
      setLoading("notfound");
      console.log("Page URL not found.");
    }
  };

  useEffect(() => {
    GetPolicyPage();
  }, [pagename]);

  useEffect(() => {
    // PolicyFind(PolicyPagesData);
  }, [pagename]);

  return (
    <MainBg>
      {loading == true ? (
        <div className=" flex items-center justify-center md:min-h-[calc(100vh-430px)] min-h-[calc(100vh-580px)] ">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-500 mx-auto mb-4"></div>
            <h1 className="text-xl font-normal text-black-700">Loading...</h1>
          </div>
        </div>
      ) : loading == "notfound" ? (
        <>
          <div className="flex flex-col items-center justify-center md:min-h-[calc(100vh-430px)] min-h-[calc(100vh-580px)] bg-white px-4 text-center">
            <h1 className="text-5xl font-bold text-orange-600">404</h1>
            <p className="mt-4 text-lg text-black-600">Page Not Found</p>
            <Link
              to="/"
              className="mt-6 px-4 py-2 text-white bg-orange-600 hover:bg-orange-700 rounded-md text-sm"
            >
              Go Home
            </Link>
          </div>
        </>
      ) : loading == "error" ? (
        <>
          <div className="flex flex-col items-center justify-center md:min-h-[calc(100vh-430px)] min-h-[calc(100vh-580px)] bg-orange-50">
            <h1 className="text-4xl font-bold text-red-600">Error</h1>
            <p className="mt-4 text-lg text-red-500">
              {"Something went wrong..."}
            </p>
          </div>
        </>
      ) : (
        <div className="md:min-h-[calc(100vh-430px)] min-h-[calc(100vh-580px)] policypage content-center">
          <div
            className={`${
              pagename == "contact" ? "text-center " : "md:px-28 px-6  py-10"
            } justify-items-center`}
          >
            {pagename == "contact-deactive" && (
              <div
                className="flex justify-start items bg-themebg mb-20 md:py-36 py-20 md:px-28 px-6"
                style={{
                  backgroundImage: `url(${dottedbg})`,
                  backgroundSize: "cover",
                }}
              >
                <h1 className="text-white text-7xl font-extrabold">
                  Contact us
                </h1>
              </div>
            )}

            <div
              className={`   ${
                pagename == "contact"
                  ? "text-left md:px-28 px-6 "
                  : "text-sm text-gray-600 pt-2"
              }`}
              dangerouslySetInnerHTML={{
                __html: policyData || "",
              }}
            ></div>
          </div>
        </div>
      )}

      <style jsx>{`
        .policypage .px-56 a {
          color: #eb5307; /* Your desired color */
          text-decoration: none; /* Optional to remove underline */
        }
        .policypage .px-56 a::hover {
          text-decoration: underline; /* Optional to remove underline */
        }

        .policypage .px-56 a:hover {
          color: #eb5307; /* Hover color */
          text-decoration: underline; /* Optional underline on hover */
        }
        .policypage p {
          margin-bottom: 14px;
        }
        .policypage p, strong {
          font-size: 18px;
          color: #6b7280;
          line-height: 28px;
        }
          .policypage h1 {
          font-size: 22px;
          color: #6b7280;
          
      `}</style>
    </MainBg>
  );
};

export default React.memo(MainPolicyPages);
